import moment from 'moment';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { map, mapTo, switchMap, mergeMap } from 'rxjs/operators';
import { message } from 'antd';
import { Type } from './redux';

const getTodayPlanId = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_TODAY_PLAN_ID),
    switchMap(({ classroomId }) =>
      fetch({
        url: '/mm-classroom/web/j/classroomManageBean.getTodayPlanId.rpc',
        body: {
          classroomId,
        },
      }),
    ),
    map(planId => ({
      type: Type.GET_TODAY_PLAN_ID_SUCCESS,
      planId,
    })),
  );
const getTeachDocs = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_TEACH_DOCS),
    switchMap(({ planId }) =>
      fetch({
        url: '/mm-classroom/web/j/classroomTeachDocBean.listTeachDocs.rpc',
        body: {
          planId,
        },
      }),
    ),
    map(docList => ({
      type: Type.GET_TEACH_DOCS_SUCCESS,
      docList,
    })),
  );
const getActivityList = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_ACTIVITY_LIST),
    switchMap(({ planId, classroomId }) =>
      fetch({
        url:
          '/mm-classroom/web/j/mocTermClassroomRpcBean.getActivityListByTeachingPlanId.rpc',
        body: {
          teachingPlanId: planId,
          classroomId,
        },
      }),
    ),
    map(activityList => ({
      type: Type.GET_ACTIVITY_LIST_SUCCESS,
      activityList,
    })),
  );

const getPublishedCount = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_PUBLISHED_COUNT),
    switchMap(({ lessonId }) =>
      fetch({
        url:
          '/mm-classroom/web/j/classroomManageBean.countPublishedResourceByLessonId.rpc',
        body: {
          lessonId:
            lessonId ||
            state$.value.mirroring.classroom?.classroom?.currentLessonId,
        },
      }),
    ),
    map(publishedCount => ({
      type: Type.GET_PUBLISHED_COUNT_SUCCESS,
      publishedCount,
    })),
  );
const getPublishedDocs = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_PUBLISHED_DOCS),
    switchMap(({ lessonId }) =>
      fetch({
        url:
          '/mm-classroom/web/j/classroomTeachDocBean.listPublishedTeachDoc.rpc',
        body: {
          lessonId,
        },
      }),
    ),
    map(publishedDocs => ({
      type: Type.GET_PUBLISHED_DOCS_SUCCESS,
      publishedDocs,
    })),
  );
const getPublishedActivitys = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_PUBLISHED_ACTIVITYS),
    switchMap(({ lessonId, classroomId }) =>
      fetch({
        url:
          '/mm-classroom/web/j/mocTermClassroomRpcBean.getActivityListByLessonId.rpc',
        body: {
          lessonId,
          classroomId,
        },
      }),
    ),
    map(publishedActivitys => ({
      type: Type.GET_PUBLISHED_ACTIVITYS_SUCCESS,
      publishedActivitys,
    })),
  );
const listHistoryActivity = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.LIST_HISTORY_ACTIVITY),
    switchMap(({ classroomId }) =>
      fetch({
        url: '/mm-classroom/web/j/mocClassroomActivityBean.pageActivity.rpc',
        body: {
          classroomId,
          publishStatus: 1,
          pageIndex: 1,
          pageSize: 100,
        },
      }),
    ),
    map(newPublishedActivityDto => ({
      type: Type.LIST_HISTORY_ACTIVITY_SUCCESS,
      newPublishedActivityDto,
    })),
  );

// 获取练习列表
const getPaperList = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_PAPER_LIST),
    switchMap(({ data }) => {
      let _data;
      const {
        pageIndex,
        pageSize,
        termId,
        status,
        classroomId,
        creatorId,
      } = data;
      if (data.supportAi === 1) {
        _data = {
          pageIndex,
          pageSize,
          keyword: '',
          termId,
          supportAiClassroom: 1,
        };
        if (creatorId !== null) {
          _data.creatorId = creatorId;
        }
      } else {
        _data = { pageIndex, pageSize, status, classroomId };
      }
      return fetch({
        method: 'POST',
        // url: '/mm-tiku/web/j/mocPaperRpcBean.getPageMocPaper.rpc',
        url:
          data.supportAi === 1
            ? '/mm-tiku/web/j/mocExamBankBean.pageExam.rpc'
            : '/mm-tiku/web/j/mocPaperRpcBean.getPageMocPaper.rpc',
        // scope: {
        //   applicationId: 'mooc',
        //   sceneId: data.classroomId,
        //   sceneType: '10002',
        // },
        // url:
        //   'https://nei.hz.netease.com/api/apimock-v2/2e8fe17f3d67eb757428a7dcc637b883mm-tiku/api/mobile/paper/list?pageSize=20&pageIndex=1&preview=&title=&status=',
        body: _data,
      });
    }),
    map(res => ({
      type: Type.GET_PAPER_LIST_SUCCESS,
      query: res?.query,
      res: res?.list ?? [],
    })),
  );
// 获取问卷库
const getQuestionnaireFromBank = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_QUESTIONNAIRE_FROM_BANK),
    switchMap(({ data }) => {
      const {
        pageIndex = 1,
        pageSize = 9,
        relativeOffset = 0,
        keyword = '',
        creatorId,
      } = data;
      return fetch({
        method: 'GET',
        url: '/mm-tiku/api/v1/offline/questionnaire/page',
        scope: {
          applicationId: 'mooc',
          sceneId: data.termId,
          sceneType: '10003',
          parent: '',
          sceneName: '',
        },
        body: {
          pageIndex,
          pageSize,
          relativeOffset,
          keyword,
          ...(creatorId !== null ? { creatorId } : {}),
        },
      });
    }),
    map(res => ({
      type: Type.GET_QUESTIONNAIRE_FROM_BANK_SUCCESS,
      query: res?.query,
      res: res?.list ?? [],
    })),
  );

const flattenPageActivityList = res =>
  (res?.list || []).reduce(
    (list, group) => list.concat(group?.mocLessonActivityVoList || []),
    [],
  );

// 获取未发布活动列表
const getUnpublishActivityList = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_UNPUBLISH_ACTIVITY_LIST),
    switchMap(({ data }) => {
      const {
        planId,
        activityType,
        classroomId,
        pageIndex = 1,
        pageSize = 100,
      } = data;
      const currentClassroomId =
        classroomId || state$.value.mirroring.classroom?.classroom?.classroomId;
      const body = {
        classroomId: currentClassroomId,
        pageIndex,
        pageSize,
        publishStatus: 0,
      };
      if (activityType !== undefined) {
        body.activityTypeList = JSON.stringify([activityType]);
      }
      if (planId) {
        body.planIdList = JSON.stringify([planId]);
      }
      return fetch({
        method: 'POST',
        url: '/mm-classroom/web/j/mocClassroomActivityBean.pageActivity.rpc',
        body,
      });
    }),
    map(res => ({
      type: Type.GET_UNPUBLISH_ACTIVITY_LIST_SUCCESS,
      query: res?.query,
      res: flattenPageActivityList(res),
    })),
  );

// 获取问卷列表
const getQuestionnaireList = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_QUESTIONNAIRE_LIST),
    switchMap(({ data }) =>
      fetch({
        url: '/mm-tiku/web/j/mocQuestionaireRpcBean.getQuestionaireList.rpc',
        // url:
        //   'https://nei.hz.netease.com/api/apimock-v2/2e8fe17f3d67eb757428a7dcc637b883/mm-tiku/web/j/mocQuestionaireRpcBean.getQuestionaireList.rpc',
        body: data,
      }),
    ),
    map(res => ({
      type: Type.GET_QUESTIONNAIRE_LIST_SUCCESS,
      query: res?.query,
      res: res?.list ?? [],
    })),
  );

// 获取讨论列表
const getDiscussionList = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_DISCUSSION_LIST),
    switchMap(({ data }) =>
      fetch({
        url: '/mm-classroom/web/j/forumRpcBean.getPostList.rpc',
        // url:
        //   'https://nei.hz.netease.com/api/apimock-v2/2e8fe17f3d67eb757428a7dcc637b883/mm-classroom/web/j/forumRpcBean.getPostListByRel.rpc',
        body: data,
      }),
    ),
    map(res => ({
      type: Type.GET_DISCUSSION_LIST_SUCCESS,
      query: res?.query,
      res: res?.list ?? [],
    })),
  );
// 获取公告列表
const getAnnouncementList = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_ANNOUNCEMENT_LIST),
    switchMap(({ data }) =>
      fetch({
        url:
          '/mm-classroom/web/j/announcementRpcBean.getAnnouncementListByRel.rpc',
        body: data,
      }),
    ),
    map(res => ({
      type: Type.GET_ANNOUNCEMENT_LIST_SUCCESS,
      query: res?.query,
      res: res?.list ?? [],
    })),
  );

// 发布教案
const publishResource = (action$, state$, { fetch }) => {
  let resResourceId;
  let resResourceContentId;
  return action$.pipe(
    ofType(Type.PUBLISH_RESOURCE),
    switchMap(
      ({
        lessonId,
        resourceType,
        resourceId,
        resourceContentId,
        planId,
        resourceRelId,
      }) => {
        resResourceId = resourceId;
        resResourceContentId = resourceContentId;
        if (resourceRelId) {
          return fetch({
            url:
              '/mm-classroom/web/j/mocClassroomActivityBean.publishActivity.rpc',
            body: {
              lessonId,
              resourceRelId,
            },
          });
        }
        const body = {
          lessonId,
          resourceType,
          resourceId,
        };
        if (planId !== null && planId !== undefined) {
          body.planId = planId;
        }

        return fetch({
          url: '/mm-classroom/web/j/classroomTeachDocBean.publishResource.rpc',
          body,
        });
      },
    ),
    map(publishDocSuccess => ({
      type: Type.PUBLISH_RESOURCE_SUCCESS,
      publishDocSuccess,
      resResourceId,
      resResourceContentId,
    })),
  );
};
// 发布问卷
const publishQuestionaire = (action$, state$, { fetch }) => {
  let resResourceId;
  let _originalResourceId;
  return action$.pipe(
    ofType(Type.PUBLISH_QUESTIONAIRE),
    switchMap(
      ({ questionaireId, classroomId, lessonId, originalResourceId }) => {
        resResourceId = questionaireId;
        _originalResourceId = originalResourceId;
        return fetch({
          url: '/mm-tiku/web/j/mocQuestionaireRpcBean.publishQuestionaire.rpc',
          body: {
            questionaireId,
            classroomId,
            lessonId,
          },
        });
      },
    ),
    map(publishActivitySuccess => ({
      type: Type.PUBLISH_QUESTIONAIRE_SUCCESS,
      publishActivitySuccess,
      resResourceId,
      originalResourceId: _originalResourceId,
    })),
  );
};
// ai课堂从库里发布问卷，先复制，再发布
const publishQuestionaireFromBank = (action$, state$, { fetch }) => {
  let _classroomId;
  let _lessonId;
  let _originalQuestionaireId;
  return action$.pipe(
    ofType(Type.PUBLISH_QUESTIONAIRE_FROM_BANK),
    switchMap(({ data }) => {
      const {
        planId,
        fromScope,
        toScope,
        questionnaireIds,
        classroomId,
        lessonId,
      } = data;
      _classroomId = classroomId;
      _lessonId = lessonId;
      _originalQuestionaireId = questionnaireIds[0];
      return fetch({
        url: `/mm-tiku/api/v1/questionnaire/copy?tagId=${planId}&tagType=10005`,
        body: {
          fromScope,
          toScope,
          questionnaireIds,
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
        scope: {
          applicationId: 'mooc',
          sceneId: `${classroomId}`,
          sceneType: '10002',
          parent: '',
          sceneName: '',
        },
      });
    }),
    mergeMap(res => {
      if (res?.[0]?.destQuestionaireId) {
        return of({
          type: Type.PUBLISH_QUESTIONAIRE,
          questionaireId: res?.[0]?.destQuestionaireId,
          originalResourceId: _originalQuestionaireId, // 原始的 id
          classroomId: _classroomId,
          lessonId: _lessonId,
        });
      }
      message.error('发布问卷失败');
      return EMPTY;
    }),
  );
};
// 发布练习
const publishExercise = (action$, state$, { fetch }) => {
  let resResourceId;
  return action$.pipe(
    ofType(Type.PUBLISH_EXERCISE),
    switchMap(({ exerciseId, classroomId, lessonId }) => {
      resResourceId = exerciseId;
      return fetch({
        url: `/mm-tiku/api/v1/paper/draft/${exerciseId}/${lessonId}/publish`,
        method: 'PUT',
        scope: {
          applicationId: 'mooc',
          sceneId: classroomId,
          sceneType: '10002',
        },
        body: {},
      });
    }),
    map(publishActivitySuccess => ({
      type: Type.PUBLISH_EXERCISE_SUCCESS,
      publishActivitySuccess,
      resResourceId,
    })),
  );
};

// 发布新版练习
const publishExerciseNew = (action$, state$, { fetch }) => {
  let resResourceId;
  let publishedResourceId;
  return action$.pipe(
    ofType(Type.PUBLISH_EXERCISE_NEW),
    switchMap(({ examId, fromExamId }) => {
      resResourceId = fromExamId || examId; // 从新版练习库要优先使用这个字段
      publishedResourceId = examId;
      return fetch({
        url: `/mm-tiku/web/j/classroomExamDraftBean.publishExam.rpc`,
        method: 'POST',
        body: {
          examId,
        },
      });
    }),
    map(publishActivitySuccess => ({
      type: Type.PUBLISH_EXERCISE_NEW_SUCCESS,
      publishActivitySuccess,
      resResourceId,
      publishedResourceId,
    })),
  );
};
// 发布讨论
const publishPost = (action$, state$, { fetch }) => {
  let resResourceId;
  return action$.pipe(
    ofType(Type.PUBLISH_POST),
    switchMap(({ postId, lessonId }) => {
      resResourceId = postId;
      return fetch({
        url: '/mm-classroom/web/j/forumRpcBean.publishPost.rpc',
        body: {
          postId,
          lessonId,
        },
      });
    }),
    map(publishActivitySuccess => ({
      type: Type.PUBLISH_POST_SUCCESS,
      publishActivitySuccess,
      resResourceId,
    })),
  );
};
// 公告
const publishAnnouncement = (action$, state$, { fetch }) => {
  let resResourceId;
  return action$.pipe(
    ofType(Type.PUBLISH_ANNOUNCEMENT),
    switchMap(({ announceId, lessonId }) => {
      resResourceId = announceId;
      return fetch({
        url:
          '/mm-classroom/web/j/announcementRpcBean.publishUniversalAnnouncement.rpc',
        body: {
          announceId,
          lessonId,
        },
      });
    }),
    map(publishActivitySuccess => ({
      type: Type.PUBLISH_ANNOUNCEMENT_SUCCESS,
      publishActivitySuccess,
      resResourceId,
    })),
  );
};

const getOnlineCourseInfo = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_ONLINE_COURSE_INFO),
    switchMap(({ classroomId }) =>
      fetch({
        url: '/mm-classroom/web/j/classroomManageBean.getOnlineCourseInfo.rpc',
        body: {
          classroomId,
        },
      }),
    ),
    map(onlineCourseInfo => ({
      type: Type.GET_ONLINE_COURSE_INFO_SUCCESS,
      onlineCourseInfo,
    })),
  );

const addTeachDocs = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.ADD_TEACH_DOCS),
    switchMap(({ query }) =>
      fetch({
        url:
          '/mm-classroom/web/j/classroomTeachDocBean.addTeachDocsToLesson.rpc',
        body: {
          ...query,
        },
      }),
    ),
    map(res => ({
      type: Type.ADD_TEACH_DOCS_SUCCESS,
      res,
    })),
  );
const saveMocTermPdfResource = (action$, state$, { fetch }) => {
  let resourceType;
  let planId;
  return action$.pipe(
    ofType(Type.SAVE_MOC_TERM_PDF_RESOURCE),
    switchMap(({ data }) => {
      resourceType = data.resourceType;
      planId = data.planId;
      const { fileName, nosBucket, nosKey, termId } = data;
      return fetch({
        url: '/web/j/resourceRpcBean.savaMocTermResourcePdfResource.rpc',
        body: {
          fileName,
          bucket: nosBucket,
          nosKey,
          termId,
        },
      }).pipe(
        switchMap(resource => {
          if (!planId) {
            return of(resource);
          }
          return fetch({
            url:
              '/mm-classroom/web/j/classroomTeachDocBean.saveResourceToPlan.rpc',
            body: {
              planId,
              resourceId: resource?.id,
              resourceType,
            },
          }).pipe(map(() => resource));
        }),
      );
    }),
    map(resource => ({
      type: Type.SAVE_MOC_TERM_PDF_RESOURCE_SUCCESS,
      resource,
    })),
  );
};

const closeLesson = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.CLOSE_LESSON),
    switchMap(({ classroomId, lessonId }) =>
      fetch({
        url: '/mm-classroom/web/j/classroomManageBean.closeLessonroom.rpc',
        body: {
          classroomId,
          lessonroomId: lessonId,
        },
      }),
    ),
    map(closeLessonResult => ({
      type: Type.CLOSE_LESSON_SUCCESS,
      closeLessonResult,
    })),
  );

const startCheckin = (action$, state$, { fetch }) => {
  let topSignType = 0;
  return action$.pipe(
    ofType(Type.START_CHECKIN),
    switchMap(
      ({
        time,
        wsClassroomId = undefined,
        wsLessonId = undefined,
        signType,
        planId,
      }) => {
        const targetId =
          wsClassroomId || state$.value.mirroring.classroom.classroomId;
        const childId =
          wsLessonId ||
          state$.value.mirroring.classroom.lessonId ||
          state$.value.mirroring.classroom?.classroom?.currentLessonId;
        const paramData = {
          targetId,
          targetType: 10,
          signStartTime: moment.now(),
          signEndTime: time,
          signClosedTime: moment()
            .add(24, 'h')
            .format('x'),
          gpsEnabled: false,
          gpsLatitude: 0,
          gpsLongitude: 0,
          signDistance: 0,
          childId,
          signType,
        };
        if (planId) {
          paramData.planId = planId;
        }
        topSignType = signType;
        return fetch({
          url:
            '/mm-classroom/web/j/mocSigninRpcBean.startUniversalSigninAction.rpc',
          body: { param: JSON.stringify(paramData) },
        });
      },
    ),
    map(() => {
      return {
        type: Type.START_CHECKIN_SUCCESS,
      };
    }),
  );
};
const startCheckinSuccess = action$ =>
  action$.pipe(
    ofType(Type.START_CHECKIN_SUCCESS),
    mapTo({ type: Type.GET_CLASSROOM_LESSON_INFO }),
  );

const getClassroomLessonInfo = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_CLASSROOM_LESSON_INFO),
    switchMap(({ classroomId }) => {
      const id = classroomId || state$.value.mirroring.classroom.classroomId;
      return fetch({
        url:
          '/mm-classroom/web/j/classroomManageBean.getClassroomLessonInfo.rpc',
        body: { classroomId: id },
      });
    }),
    map(res => ({
      type: Type.GET_CLASSROOM_LESSON_INFO_SUCCESS,
      data: res,
    })),
  );

// 从教案库发布教案
const publishTeachDocFromBank = (action$, state$, { fetch }) => {
  let resResourceId;
  return action$.pipe(
    ofType(Type.PUBLISH_TEACH_DOC_FROM_BANK),
    switchMap(({ lessonId, resourceId }) => {
      resResourceId = resourceId;
      return fetch({
        url:
          '/mm-classroom/web/j/classroomTeachDocBean.publishResourceFromBank.rpc',
        body: { lessonId, resourceId },
      });
    }),
    map(res => ({
      type: Type.PUBLISH_TEACH_DOC_FROM_BANK_SUCCESS,
      publishDocFromBankSuccess: res,
      resResourceId,
    })),
  );
};

// 获取教案库中的课件列表
const getTeachDocsFromBank = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_TEACH_DOCS_FROM_BANK),
    switchMap(({ data }) => {
      let _url;
      let _data;

      if (data.supportAi) {
        // _url = '/web/j/resourceRpcBean.listAiTeachDocsFromList.rpc';
        // data.termId = data.virtualTermId;
        // delete data.virtualTermId;
        // delete data.supportAi;
        // _data = { pageMocTermResourceParam: JSON.stringify(data) };
        _url = '/web/j/resourceRpcBean.pageMocTermResource.rpc';
        _data = {};
        const pageMocTermResourceParam = {
          pageIndex: data.pageIndex || 1,
          pageSize: 8,
          contentName: '',
          nodeIds: [],
          contentTypes: data.contentTypes,
          termId: data.termId,
        };
        if (data.uploaderId) {
          pageMocTermResourceParam.uploaderId = data.uploaderId;
        }
        _data.pageMocTermResourceParam = JSON.stringify(
          pageMocTermResourceParam,
        );
      } else {
        _url =
          '/mm-classroom/web/j/classroomTeachDocBean.listTeachDocsFromList.rpc';
        _data = data;
        delete _data.supportAi;
        delete _data.virtualTermId;
        delete _data.termId;
        delete _data.contentTypes;
      }
      return fetch({
        url: _url,
        body: _data,
      });
    }),
    map(res => ({
      type: Type.GET_TEACH_DOCS_FROM_BANK_SUCCESS,
      query: res?.query,
      res: res?.list ?? [],
    })),
  );

// const listAiTeachDocsFromList = (action$, state$, { fetch }) =>
//   action$.pipe(
//     ofType(Type.GET_TEACH_DOCS_FROM_BANK),
//     switchMap(({ data }) => {
//       return fetch({
//         url: '/web/j/resourceRpcBean.listAiTeachDocsFromList.rpc',
//         body: data,
//       });
//     }),
//     map(res => ({
//       type: Type.GET_TEACH_DOCS_FROM_BANK_SUCCESS,
//       query: res?.query,
//       res: res?.list ?? [],
//     })),
//   );

// 从题库加联系
const addExamFromBank = (action$, state$, { fetch }) => {
  return action$.pipe(
    ofType(Type.ADD_EXAM_FROM_BANK),
    switchMap(({ examIds, planId, classroomId }) => {
      return fetch({
        url: `/mm-tiku/web/j/classroomExamDraftBean.addExamFromBank.rpc`,
        method: 'POST',
        body: {
          examIds,
          planId,
          classroomId,
        },
      });
    }),
    map(res => ({
      type: Type.PUBLISH_EXERCISE_NEW,
      examId: res?.length && res[0]?.id,
      fromExamId: res?.length && res[0]?.fromExamId, // 从新版练习库才有这个字段
    })),
  );
};

export default [
  getTodayPlanId,
  getTeachDocs,
  getActivityList,
  getPaperList,
  getQuestionnaireFromBank,
  getUnpublishActivityList,
  getQuestionnaireList,
  getDiscussionList,
  getAnnouncementList,
  getPublishedCount,
  getPublishedDocs,
  getPublishedActivitys,
  listHistoryActivity,
  publishResource,
  publishQuestionaire,
  publishQuestionaireFromBank,
  publishExercise,
  publishExerciseNew,
  publishPost,
  publishAnnouncement,
  getOnlineCourseInfo,
  addTeachDocs,
  saveMocTermPdfResource,
  startCheckin,
  getClassroomLessonInfo,
  startCheckinSuccess,
  closeLesson,
  publishTeachDocFromBank,
  getTeachDocsFromBank,
  addExamFromBank,
];
